import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  myBookingData: null,
  myBookingStatus: null,
};

const myBookingSlice = createSlice({
  name: "myBooking",
  initialState,
  reducers: {
    setMyBookingData: (state, action) => {
      state.myBookingData = action.payload;
    },
    setMyBookingStatus: (state, action) => {
      state.myBookingStatus = action.payload;
    },
  },
});

export const { setMyBookingData, setMyBookingStatus } = myBookingSlice.actions;

export default myBookingSlice.reducer;
